import Button from "@syntensor/common/components/button";
import getCopy from "@syntensor/common/data/copy";

import styles from "./list_users.module.css";
import { ICognitoUser } from "@syntensor/common/types";
import { navigateTo } from "@syntensor/common/browser_history";

export default function EditButton(row: ICognitoUser) {
  return (
    <div className={styles.reinviteButton}>
      <Button
        role="subtle"
        onClick={() => {
          localStorage.setItem("editUser", JSON.stringify(row));
          navigateTo("/users/edit");
        }}
      >
        {getCopy("admin_users_edit-user")}
      </Button>
    </div>
  );
}
